import React, { Component } from "react";
import { bool, shape, func } from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import { withFormik, Form, Field } from "formik";

import { actions as layoutActions } from "reducers/layout";
import { actions as sessionActions, selectors as sessionSelectors } from "reducers/session";

import Head from "pages/_components/Head";
import { resizableRoute } from "pages/_components/Resizable";
import { dispatchV3ShellLayout, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import MainContainer from "pages/_components/MainContainer";
import Enviroments from "pages/_components/Enviroments";
import Button from "pages/_components/Button";
import I18n from "../_components/I18n";

class ChangeEnvironment extends Component {
    static propTypes = {
        isSubmitting: bool,
        history: shape({
            goBack: func,
        }).isRequired,
        environments: shape([]).isRequired,
        activeEnvironment: shape([]).isRequired,
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        isSubmitting: false,
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell && isUxDashboardImprovementsEnabled()) {
            dispatchV3ShellLayout(dispatch, {
                titleKey: "settings.changeEnvironment",
                goBackPath: "/settings",
                rightContentMobile: null,
                scopes: ["settings"],
            });
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell && isUxDashboardImprovementsEnabled()) {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setHeaderTitle(""));
            dispatch(layoutActions.setHeaderSubtitle(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        }
    }

    backButtonAction = () => {
        const { history } = this.props;
        history.goBack();
    };

    render() {
        const { environments, activeEnvironment, isSubmitting, isDesktop, embeddedInV3Shell } = this.props;
        const isShellActive = embeddedInV3Shell && isUxDashboardImprovementsEnabled();
        return (
            <>
                {(isDesktop || !isShellActive) && (
                    <Head headerClassName="header-environment" onBack={this.backButtonAction} />
                )}

                <MainContainer>
                    <Form className="above-the-fold login-desktop-wrapper">
                        <section className="container--layout flex-grow align-items-center px-2">
                            <Grid className="form-content">
                                <Row className="justify-content-center pb-4">
                                    <I18n id="settings.changeEnvironment" component="h1" />
                                </Row>
                                <Row className="justify-content-left">
                                    <Col sm={12} md={9} lg={6} xl={6} className="col-12">
                                        <Field
                                            name="environment"
                                            environments={environments}
                                            component={Enviroments}
                                            legendTextID="settings.changeEnvironment"
                                            activeEnvironment={activeEnvironment}
                                            fromChangeEnvironmentPage
                                        />
                                    </Col>
                                </Row>
                            </Grid>
                        </section>
                        <section className="container--layout">
                            <Grid className="form-content">
                                <Row className="justify-content-center">
                                    <Col sm={12} md={9} lg={6} xl={6} className="col col-12">
                                        <Button
                                            type="submit"
                                            loading={isSubmitting}
                                            label="global.confirm"
                                            bsStyle="primary"
                                        />
                                    </Col>
                                </Row>
                            </Grid>
                        </section>
                    </Form>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    environments: Object.entries(sessionSelectors.getEnvironments(state)),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: ({ activeEnvironment }) => ({
            environment: activeEnvironment.id,
            rememberEnvironment: false,
        }),
        handleSubmit: ({ environment, rememberEnvironment }, formikBag) => {
            formikBag.props.dispatch(sessionActions.changeEnvironment(environment, rememberEnvironment, formikBag));
        },
    }),
    resizableRoute,
)(ChangeEnvironment);
